<template>

  <ul
    class="tags"
    :class="{'box-loading': loading}">

    <li
      v-for="(item, index) in value"
      :key="index"
      class="item"
      :style="{'background': dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}">
      {{ item }}
      <span
        class="remove"
        v-if="enable"
        @click="removeTag(index)">
        <i class="fas fa-times" />
      </span>
    </li>
    <li
      class="add"
      v-if="enable">
      <div
        class="icon"
        @click="showOptions =! showOptions"
        :style="{'background': dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}">+ tag</div>
      <div
        class="list card"
        v-if="showOptions">
        <input
          type="text"
          class="form-control"
          v-model="keywords"
          :placeholder="$t('Find')">
        <ul
          class="list-group list-group-flush">
          <a
            v-for="(item, index) in optionsFiltered"
            :key="index"
            class="list-group-item list-group-item-action"
            href="javascript:void(0)"
            @click="addTag(item)">
            {{ item }}
            </a>
        </ul>
      </div>
    </li>
  </ul>
  
</template>

<script>
export default {
  name: 'SetTag',
  components: {
  },
  props: {
    value: {
      type: Array,
      default: () => { return [] }
    },
    type: {
      type: String,
      default: 'candidate'
    },
    enable: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true,
      keywords: '',
      options: [],
      showOptions: false
    }
  },
  computed: {
    selected () {
      return this.value || []
    },
    optionsFiltered () {
      return this.options.filter(tag => {
        return tag.toLowerCase().search(this.keywords.toLowerCase()) >= 0 && !this.selected.includes(tag)
      })
    }
  },
  created () {
    this.loadTags()
  },
  methods: {
    /*
    loadTags
    */
    loadTags () {
      this.$store
      .dispatch('getTags', {
        type: this.type,
        sort: 'name',
        limit: 1000
      })
      .then((result) => {
        this.loading = false
        this.options = result.docs.map(v => v.name)
      })
    },
    addTag (tag) {
      this.showOptions = false
      // console.log([ ...this.selected, tag ])
      this.$emit('input', [ ...this.selected, tag ])
    },
    removeTag (index) {
      let currentTags = this.$clone(this.selected)
      currentTags.splice(index, 1)
      this.$emit('input', currentTags)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tags{
    list-style: none;
    padding: 0;
    margin: -2px;
    z-index: 10;
    display: inline;
  }
    .tags:before{
      content: "."; 
      visibility: hidden; 
      display: block; 
      height: 0; 
      clear: both;
    }
  .tags > li{
    float: left;
    margin: 2px;
    padding: 0;
  }
  .tags > li.item,
  .tags > li.add div.icon{
    padding: 4px 8px;
    font-size: 13px;
    line-height: 1em;
    border-radius: 5px;
    background: rgba(0,0,0,0.1);
    /* background: rgba(255,255,255,0.1); */
  }
    .tags > li.add > .icon{
      cursor: pointer;
    }
    .tags > li .remove{
      cursor: pointer;
      vertical-align: top;
    }
  /* list */
  .list{
    position: absolute;
    z-index: 2;
    width: 200px;
  }
    .list .form-control{
      border: 0;
    }
    .list .list-group{
      max-height: 300px;
      overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/Fields/SetTag.vue